const API_BASE_URL = 'https://server.hugssam.com/center/';

export { API_BASE_URL };
